var $2c9c1dfc72c7bac2$exports = {};
$2c9c1dfc72c7bac2$exports = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


export {$2c9c1dfc72c7bac2$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
